module.exports = __webpack_public_path__ + "fonts/FetteUNZFraktur.6fac792f.woff2";